import * as React from "react";
function SvgDots3V(
  props: React.SVGProps<SVGSVGElement>,
  svgRef?: React.Ref<SVGSVGElement>
) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 20 20"
      ref={svgRef}
      {...props}
    >
      <circle cx={10} cy={2} r={2} />
      <circle cx={10} cy={18} r={2} />
      <circle cx={10} cy={10} r={2} />
    </svg>
  );
}
const ForwardRef = React.forwardRef(SvgDots3V);
const MemoForwardRef = React.memo(ForwardRef);
export default MemoForwardRef;
